import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MenuCategory, MenuProduct, Store } from '../interface/menu.interface';
import { StorePopupComponent } from '../popup/store-popup/store-popup.component';
import { CommonService } from '../service/common.service';
import { MenuService } from '../service/menu.service';
import { UserService } from '../service/user.service';

declare let gtag: Function;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit, AfterViewInit, OnDestroy {

  productList: MenuProduct[];
  categoryList: MenuCategory[];
  form: FormGroup;
  isProductLoading: boolean = true;

  selectedStore: Store;
  private unsubscribe$ = new Subject();

  constructor(
    private menuService: MenuService,
    private fb: FormBuilder,
    private userService: UserService,
    private commonService: CommonService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.commonService.updateTitle('Products');
    const selectedCategory: string = this.router.getCurrentNavigation().extras.state ? this.router.getCurrentNavigation().extras.state.category : 'ALL CATEGORY';
    const deviceId = this.userService.getDeviceId();

    this.form = this.fb.group({
      sort: ['alphaup', [Validators.required]],
      category: [selectedCategory, [Validators.required]],
      deviceID: [deviceId],
      keyword: [''],
    });
  }

  ngOnInit(): void {
    this.userService.selectedStore$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (!data) {
          return;
        }
        this.selectedStore = data;

        // products
        let value = this.form.value;
        this.menuService.getProduct(value, this.selectedStore.id).subscribe((response) => {
          this.isProductLoading = false;
          this.productList = response.data;
          // this.trackViewItemList(this.productList, value.category);
        });
      });

    // categories
    this.menuService.categories$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (!data) {
          return;
        }
        this.categoryList = data.filter(category => category.allow_order === '1');
      });
  }

  ngAfterViewInit(): void {
    // detect changes on sort & category
    this.form.valueChanges.subscribe((changes) => {
      this.isProductLoading = true;
      this.menuService.getProduct(changes, this.selectedStore.id).subscribe((response) => {
        this.isProductLoading = false;
        this.productList = response.data;
        // this.trackViewItemList(this.productList, changes.category);
        return;
      });
    });
  }

  private trackViewItemList(products: MenuProduct[], category?: string): void {
    if (typeof gtag !== 'function' || !products || products.length === 0) {
      return;
    }

    const currentCategory = category || this.form?.get('category')?.value;

    const items = products.map((product, index) => ({
      item_id: String(product.prod_id),
      item_name: product.prod_name,
      item_category: currentCategory,
      price: +product.prod_price || 0,
      index: index
    }));

    gtag('event', 'view_item_list', {
      debug_mode: true,
      item_list_id: 'main_menu',
      item_list_name: currentCategory !== 'ALL CATEGORY' ? currentCategory : 'Main Menu',
      items: items
    });
    console.log('GA4 view_item_list tracked:', items);
  }

  selectProduct(product: MenuProduct): void {
    if (typeof gtag === 'function' && product) {
      const currentCategory = this.form?.get('category')?.value || 'ALL CATEGORY';
      // gtag('event', 'select_item', {
      //   debug_mode: true,
      //   item_list_id: 'main_menu',
      //   item_list_name: currentCategory !== 'ALL CATEGORY' ? currentCategory : 'Main Menu',
      //   items: [{
      //     item_id: String(product.prod_id),
      //     item_name: product.prod_name,
      //     item_category: currentCategory !== 'ALL CATEGORY' ? currentCategory : 'Rolls',
      //     price: +product.prod_price || 0
      //   }]
      // });
      gtag('event', 'view_item', {
        debug_mode: true,
        currency: 'AUD',
        value: product.prod_price,
        items: [{
          item_id: product.prod_id,
          item_name: product.prod_name,
          item_category: currentCategory !== 'ALL CATEGORY' ? currentCategory : 'Rolls',
          price: +product.prod_price || 0,
          quantity: 1
        }]
      });
    }
    this.menuService.setSelectedProduct(product);
    this.router.navigate(['product', this.commonService.dashCase(product.prod_name)]);
  }

  selectStore(): void {
    this.dialog.open(StorePopupComponent, {
      width: '800px'
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
